var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7501 17V17.6875C13.7501 18.4168 13.4604 19.1163 12.9446 19.632C12.4289 20.1478 11.7294 20.4375 11.0001 20.4375C10.2707 20.4375 9.57127 20.1478 9.05555 19.632C8.53982 19.1163 8.25009 18.4168 8.25009 17.6875V17M18.377 15.6005C17.2735 14.25 16.4945 13.5625 16.4945 9.83926C16.4945 6.42969 14.7534 5.21496 13.3204 4.625C13.1301 4.5468 12.9509 4.36719 12.8929 4.17168C12.6415 3.31617 11.9368 2.5625 11.0001 2.5625C10.0634 2.5625 9.35825 3.3166 9.10947 4.17254C9.05146 4.3702 8.87228 4.5468 8.68193 4.625C7.2472 5.21582 5.50782 6.42625 5.50782 9.83926C5.50568 13.5625 4.72665 14.25 3.62322 15.6005C3.16603 16.16 3.5665 17 4.36614 17H17.6383C18.4337 17 18.8316 16.1574 18.377 15.6005Z",
    stroke: "#032A4B",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6465,
    cy: 7.5,
    r: 3.5,
    fill: "#E37B00",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f7aa0c8a6ce82ae41d23a0ce804648c8.svg";
export { ForwardRef as ReactComponent };